import { createSlice } from "@reduxjs/toolkit";
import { createCustomAsyncThunk, defaultEntityAdapter } from "./utils";
import { logBookService } from "../services/lessonService";
import { useDispatch, useSelector } from "react-redux";
import React from "react";

export const getLogBookItems = createCustomAsyncThunk(
    "logBookItems/get",
    async params => await logBookService.getItems(params)
)

export const updateLogBookItem = createCustomAsyncThunk(
    "logBookItem/update",
    async data => data.id ? logBookService.patchItems(data) : logBookService.postItems(data)
)

const logBookItemsSlice = createSlice({
    name: "logBooItems",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null
    }),
    extraReducers: builder => {
        builder
            .addCase(getLogBookItems.pending, state => { state.isLoading = true })
            .addCase(getLogBookItems.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getLogBookItems.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })


            .addCase(updateLogBookItem.pending, state => { state.isLoading = true })
            .addCase(updateLogBookItem.fulfilled, (state, action) => {
                defaultEntityAdapter.upsertOne(state, action.payload)
                state.isLoading = false
            })
            .addCase(updateLogBookItem.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })
    }
})

export const logBookItemSelectors = defaultEntityAdapter.getSelectors(x => x.logBookItems)

export default logBookItemsSlice.reducer

export const useLogBookItems = lesson => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (lesson) { dispatch(getLogBookItems({ lesson: lesson.id })) }
    }, [dispatch, lesson])

    const logBook = useSelector(logBookItemSelectors.selectAll)
    const logBookIsLoading = useSelector(x => x.logBookItems.isLoading)

    return { logBook, logBookIsLoading }
}